/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardCctDto } from './DashboardCctDto';
import {
    DashboardCctDtoFromJSON,
    DashboardCctDtoFromJSONTyped,
    DashboardCctDtoToJSON,
} from './DashboardCctDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardCctDtoPaginatedResults
 */
export interface DashboardCctDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardCctDto>}
     * @memberof DashboardCctDtoPaginatedResults
     */
    results?: Array<DashboardCctDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardCctDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardCctDtoPaginatedResults interface.
 */
export function instanceOfDashboardCctDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCctDtoPaginatedResultsFromJSON(json: any): DashboardCctDtoPaginatedResults {
    return DashboardCctDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardCctDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCctDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardCctDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardCctDtoPaginatedResultsToJSON(value?: DashboardCctDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardCctDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

